import React from 'react';
import { useRouter } from 'next/router';
import { ErrorBoundary } from 'next/dist/client/components/error-boundary';
import { COLLECTION_MECHANIC } from '@/models/collection-mechanic/collection-mechanic.types';
import PartnersSection from '@/modules/partner/partners-section';
import { CLICK_LOCATION } from '@/utils/register-partner-click/register-partner-click.types';
import SearchSection from '@/components/integrated/search-section';
import GenericErrorSection from '@/modules/generic-error-section';
import { CollectOnlinePageProperties } from './collect-online-page.types';
import styles from './collect-online-page.module.scss';
import ContentfulRenderSection from '../contentful-section';

const CollectOnlinePage = ({
  partnersSectionAriaLabel,
  partnersSectionProperties,
  topSection,
  heroSection,
}: CollectOnlinePageProperties) => {
  const router = useRouter();
  const searchResultsList = !!router.query.search;

  return (
    <div className={styles['collect-online-page']}>
      {heroSection && (
        <SearchSection
          searchButtonLabel={heroSection.searchButtonLabel}
          noResultsLabel={heroSection.noResultsLabel}
          image={heroSection.image}
          pillLabel={heroSection.pillLabel}
          heading={heroSection.heading}
          body={heroSection.body}
          button={heroSection.button}
          backgroundColour={heroSection.backgroundColour}
          enableSearch={heroSection.enableSearch}
          wasRateLabel={heroSection.wasRateLabel}
          fromRateLabel={heroSection.fromRateLabel}
          upToRateLabel={heroSection.upToRateLabel}
          closeButtonLabel={heroSection.closeButtonLabel}
        />
      )}

      {topSection?.length > 0 && (
        <ErrorBoundary errorComponent={GenericErrorSection}>
          <ContentfulRenderSection sections={topSection} />
        </ErrorBoundary>
      )}
      {partnersSectionProperties && (
        <ErrorBoundary errorComponent={GenericErrorSection}>
          <PartnersSection
            {...partnersSectionProperties}
            showHighestRate
            clickLocation={
              searchResultsList
                ? CLICK_LOCATION.SEARCH_RESULTS
                : CLICK_LOCATION.COLLECT_ONLINE
            }
            collectionMechanic={[
              COLLECTION_MECHANIC.EStore,
              COLLECTION_MECHANIC.Manual,
            ]}
            sectionAriaLabel={partnersSectionAriaLabel}
          />
        </ErrorBoundary>
      )}
    </div>
  );
};

export default CollectOnlinePage;
